import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGetListBonuses = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_BONUSES_LIST
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetListBonusesAction(data.data));
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}


export {
    setGetListBonuses as SetGetListBonuses
}